/*eslint no-underscore-dangle:0*/
(function () {
	'use strict';

	var module = 'localiser';
	var exports = {};
	var AVAILABLE_LANGUAGES = ['en', 'de'];

	var months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	];

	var Localiser = {
		// map translation strings
		strings: {},

		string: function (key) {
			var strings = Localiser.strings;
			var strings_en = Localiser.strings_en;
			var args = [].slice.call(arguments, 1);
			if (strings.hasOwnProperty(key)) {
				if (typeof strings[key] === 'function') {
					return strings[key](args);
				} else {
					return Localiser.replace(strings[key], args);
				}
			} else if (strings_en && strings_en.hasOwnProperty(key)) {
				// Fall back to English
				if (typeof strings_en[key] === 'function') {
					return strings_en[key](args);
				} else {
					return Localiser.replace(strings_en[key], args);
				}
			} else {
				// todo: debug mode
				// console.log('Not found i18n key:', key);
				return key;
			}
		},

		localize: function (key, args) {
			// cast key to string - well key SHOULD be string, but we should not crash if not and output correct error string
			key = [String(key).trim()];
			if (args) {
				key = key.concat(args);
			}

			return Localiser.string.apply(Localiser, key);
		},

		replace: function (str, args) {
			for (var i = 0, len = args.length; i < len; i++) {
				str = str.replaceAll('{' + i + '}', args[i]);
			}
			return str;
		},

		add: function (key, fn) {
			Localiser.strings[key] = fn;
		},

		setLanguage: function (langCode, langContent) {
			exports.language = langCode;
			exports.loc.strings = langContent;
		},

		translateTemplate: function (templateContent) {
			var codeRegexp = /\{\{str-(.*?)\}\}/gi;

			var translatedTemplate = templateContent.replace(codeRegexp, function (match, key) {
				return Localiser.string(key);
			}.bind(this));

			return translatedTemplate;
		},

		/**
		 * Simple date formatter
		 * @param d - Date object or timestamp
		 * @param format:
		 *  YYYY - year
		 *  MM - month number
		 *  MMMM - full month name
		 *  MMM - short month name
		 *  DD - day
		 *  HH - hours (24h format)
		 *  hh - hours (12h format)
		 *  mm - minutes
		 *  ss - seconds
		 *  A - AM/PM
		 *  a - am/pm
		 */
		date: function (d, format) {
			// support for timestamp
			+d === d && (d = new Date(d));

			var year = d.getFullYear();
			var month = d.getMonth() + 1;
			var day = d.getDate();
			var hours = d.getHours();
			var minutes = d.getMinutes();
			var seconds = d.getSeconds();
			var ampm = hours >= 12 ? 'PM' : 'AM';
			month < 10 && (month = '0' + month);
			hours < 10 && (hours = '0' + hours);
			minutes < 10 && (minutes = '0' + minutes);
			seconds < 10 && (seconds = '0' + seconds);

			return format
				.replace('a', ampm.toLowerCase())
				.replace('A', ampm)
				.replace('YYYY', year)
				.replace('MMMM', this.string(months[month - 1]))
				.replace('MMM', this.string('short-' + months[month - 1]))
				.replace('MM', month)
				.replace('DD', day)
				.replace('HH', hours)
				.replace('hh', ((parseInt(hours, 10) + 11) % 12 + 1))
				.replace('mm', minutes)
				.replace('ss', seconds);
		}
	};

	exports.getCurrentLanguage = function (isoCode) {
		// use lang from query parameters from desktop app
		var urlParams;
		if (window.location.search) {
			urlParams = new URLSearchParams(window.location.search);
		} else {
			// cover case when there is also #hash in URL, then we have to extract query params in different way
			var queryStrings = window.location.href.indexOf('?') ? window.location.href.split('?')[1] : null;
			urlParams = new URLSearchParams(queryStrings);
		}

		var lang = urlParams.get('lang');
		
		if (!lang) {
			lang = window.sessionStorage.getItem('checkoutLang');
		}

		// if this is not available then try to set lang based on
		// browser's data (only if we have translation for browser language)
		if (!lang) {
			var browserSettingsLang = (window.navigator.userLanguage || window.navigator.language).toLowerCase().substr(0, 2);
			if (AVAILABLE_LANGUAGES.indexOf(browserSettingsLang)) {
				lang = browserSettingsLang;
			}
		}

		if (!lang) {
			// If we don't have translation for browser langauge (ie. Norwegian) then use language from XC user settings (English)
			lang = window.localStorage.getItem('lang');
		}

		// language can be de/en (from newsletter) or deu/enu (from desktop app)
		if (lang === 'deu') {
			lang = 'de';
		} else if (lang === 'enu' || lang === 'eng') {
			lang = 'en';
		}

		// make sure that the language can be used
		if (AVAILABLE_LANGUAGES.indexOf(lang) == -1) {
			lang = 'en';
		}

		if (isoCode) {
			if (lang === 'en') {
				return 'en-GB';
			} else if (lang === 'de') {
				return 'de-DE';
			}
		} else {
			return lang;
		}
	};

	// !! DO NOT REMOVE COMMENTS - THEY ARE USED TO INJECT TRANSLATION VARIABLES
	exports.loc = Localiser;
	exports.loc.language = /*lang*/''/*lang*/;
	exports.loc.strings = /*localisedStrings*/{}/*localisedStrings*/;
	exports.tpl = /*templates*/{}/*templates*/;
	if (!exports.loc.language) {
		exports.loc.language = 'en';
	}
	/*extraContent*//*extraContent*/

	this[module] = exports;

}).call(this);


// WEBPACK FOOTER //
// ./src/i18n/i18n_.js